import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UserController from "../../../../services/system/user/user-controller";
import Utils from "../../../../utils/utils";
import AdminController from "../../../../services/system/admin-controller";

class modalEditUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fullName: '',
            role: '',
            username: '',
            uuid: '',
            reason: '',
            password: '12345678@@',
            isChangePass: false,
            showBlock: true,
            signupInfo: null
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({showLoading: true},
                () => {
                    this.state = {
                        role: nextProps.listGroupUser[0]?.role,
                    };
                    console.log(nextProps.listGroupUser[0]?.role)
                    this.detailUser(nextProps.id)
                }
            )
        }
    }
    detailUser(userId) {
        UserController.detailUser(userId, res => {
            if (res.success) {
                let data = res.data;
                this.setState(
                    {
                        fullName : data.fullName,
                        role : data.rolesRes.length < 1 ? "": data.rolesRes[0].role,
                        isChangePass : false,
                        status : data.status == "ACTIVE",
                        username : data.username,
                        uuid : data.uuid,
                        showLoading : false,
                    }, () =>{

                    }
                );
            } else {
                toast.error(res.message[0] =="FORBIDDEN"? "Bạn không có quyền thực hiện chức năng này!" : res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                });
            }
        });
    }
    editUser = () => {
        console.log("editUser")
        console.log(this.state.role)
        if (this.state.role == ""){
            toast.error("Vui lòng chọn nhóm người dùng!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        }else {
            let payload = {
                "fullName": this.state.fullName,
                "groups": [this.state.role],
                "password": this.state.isChangePass?this.state.password: "",
                "status": this.state.status?"ACTIVE":"INACTIVE",
                "username": this.state.username,
            }
            AdminController.adminEditUser(payload, res => {
                if (res.success) {
                    toast.success("Cập nhật người dùng thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.error(res.message[0] =="FORBIDDEN"? "Bạn không có quyền thực hiện chức năng này!" : res.message[0], {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    });
                }
            })
        }
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Sửa thông tin người dùng</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên đăng nhập(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nhập tên đăng nhập"
                                        disabled="true"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.username}
                                        onChange={(event) => {
                                            this.setState({
                                                username: Utils.filterNormalCharacter(event.target.value).trim()
                                            })
                                        }}
                                    />
                                </div>

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên hiển thị(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nhập tên hiển thị"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.fullName}
                                        onChange={(event) => {
                                            this.setState({
                                                fullName: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Nhóm người dùng(<span  style={{color: "red",}}>*</span>)</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.role}
                                        onChange={(e) => {
                                            this.state.role = e.target.value;
                                            this.setState({
                                                role: e.target.value,
                                                inEditing: true
                                            })
                                        }}
                                    >
                                        {this.props.listGroupUser?.map((item, index) => <option value={item.role}>{item.role}</option>)}
                                    </select>
                                </div>
                                <div className="col-12 d-flex mt-3">
                                    <label className="col-6 label-item pl-0"></label>
                                    <label>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                const value = this.state.status;
                                                this.setState({status: !value});
                                            }}
                                            checked={this.state.status}
                                        />
                                        {' '}
                                        Kích hoạt
                                    </label>
                                </div>
                                <div className="col-12 d-flex mt-3">
                                    <label>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                const value = this.state.isChangePass;
                                                this.setState({isChangePass: !value});
                                            }}
                                            checked={this.state.isChangePass}
                                        />
                                        {' '}
                                        Khôi phục mật khẩu mặc định: <span  style={{color: "red",}}>12345678@@</span>
                                    </label>
                                </div>
                            </div>
                        </div>


                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.editUser()}
                                >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default modalEditUser